import { ButtonIcon, IconUndo } from 'braid-design-system';
import type { ComponentProps } from 'react';

const UnhideJobButton = ({
  id,
  label,
  onClick,
}: {
  id: string;
  label: string;
  onClick: ComponentProps<typeof ButtonIcon>['onClick'];
}) => (
  <ButtonIcon
    size="standard"
    id={id}
    label={label}
    onClick={onClick}
    icon={<IconUndo />}
    data={{ automation: 'undo-hide-job-button' }}
    variant="transparent"
  />
);

export default UnhideJobButton;
